/**
 * Pagination algorith with ellipsis
 * Reference: https://gist.github.com/kottenator/9d936eb3e4e3c3e02598
 *
 * @param {number} currentPage current selected page
 * @param {number []} totalPages total range of pages
 * @returns {number []} rangeWithEllipsis returns array with calculated ellipsis placement
 */

var pagination = function pagination(currentPage, totalPages) {
  var current = currentPage;
  var last = totalPages === null || totalPages === void 0 ? void 0 : totalPages.length;
  var delta = 2; // Variable used to show the previous or next '2' pages
  var leftBoundary = current - delta;
  var rightBoundary = current + delta + 1;
  var rangeWithoutEllipsis = [];
  var rangeWithEllipsis = [];
  var temp = undefined;

  // Generate initial range array without ellipsis
  for (var i = 1; i <= last; i++) {
    if (i === 1 || i === last || i >= leftBoundary && i < rightBoundary) {
      rangeWithoutEllipsis.push(i);
    }
  }

  // Generate final range array with ellipsis
  for (var _i = 0, _rangeWithoutEllipsis = rangeWithoutEllipsis; _i < _rangeWithoutEllipsis.length; _i++) {
    var _i2 = _rangeWithoutEllipsis[_i];
    if (temp) {
      if (_i2 - temp === 2) {
        rangeWithEllipsis.push(temp + 1);
      } else if (_i2 - temp !== 1) {
        rangeWithEllipsis.push('...');
      }
    }
    rangeWithEllipsis.push(_i2);
    temp = _i2;
  }
  return rangeWithEllipsis;
};

export { pagination as default };
